import styled from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const RadioIconWrapper = styled.div ``;
export const RadioContainer = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 5.5rem;

  padding: 1.3rem 2rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: ${({ theme, isDisabled }) => isDisabled
    ? `1px solid ${theme.colors.borders.disabled};`
    : `1px solid ${theme.colors.borders.default};`};

  background-color: ${({ theme, isChecked }) => isChecked && `${theme.colors.surface.interactiveDefault};`};
  background-color: ${({ theme, isDisabled }) => isDisabled && `${theme.colors.surface.disabled};`};

  &:hover {
    ${RadioIconWrapper} .middle_circle {
      ${({ isDisabled, isChecked, theme }) => !isDisabled &&
    `background-color: ${theme.colors.surface.interactiveDefault};
      ${!isChecked && `border: 1px solid ${theme.colors.borders.highlight};`}`}
    }
    background-color: ${({ theme, isDisabled }) => !isDisabled && `${theme.colors.surface.interactiveDefault};`};
  }
`;
export const Opacity = styled.div `
  ${({ isDisabled }) => isDisabled && `opacity:0.5;`};
`;
export const RadioContent = styled.div `
  display: flex;
  align-items: center;
`;
export const IconWrapper = styled.div `
  width: ${({ iconSize }) => iconSize}rem;
  display: flex;
`;
export const IconImg = styled.img `
  width: 100%;
`;
export const RadioText = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0.8rem;
  margin-right: 1.1rem;
  text-align: start;
`;
export const RadioWrapper = styled.div `
  display: flex;
  gap: 1.6rem;
  align-items: center;
`;
export const TitleWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;
//# sourceMappingURL=styles.js.map